import React from 'react'

import { arrayOf, number, string } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import StartCta from './Components/StartCta/StartCta'

// Every hero render is exported at this size, so the intrinsic ratio is known even if the
// content store omits the dimensions -- the box stays reserved and the hero cannot shift.
const HERO_WIDTH = 1080
const HERO_HEIGHT = 617

// The <h1> and copy come first in the DOM so the heading leads the document; the SCSS
// handles the two-column split and the mobile stack.
function Hero({
  title = '',
  paragraphs = EMPTY_ARRAY,
  imageSrc = '',
  imageAlt = '',
  imageWidth = HERO_WIDTH,
  imageHeight = HERO_HEIGHT,
  ctaLabel = '',
  subscriptionPaymentFormUrl = '',
  studioUrl = '',
}) {
  if (!title) return null

  return (
    <section className="ai-generator-landing__hero" aria-labelledby="ai-generator-landing-hero-title">
      <div className="ai-generator-landing__hero-container">
        <div className="ai-generator-landing__hero-text">
          <h1 id="ai-generator-landing-hero-title" className="ai-generator-landing__hero-title cgt-heading-600">
            {title}
          </h1>
          {paragraphs.map((paragraph) => (
            <p key={paragraph} className="ai-generator-landing__hero-paragraph cgt-body-md">{paragraph}</p>
          ))}
          {ctaLabel && (
            <StartCta label={ctaLabel} subscriptionPaymentFormUrl={subscriptionPaymentFormUrl} studioUrl={studioUrl} />
          )}
        </div>
        {imageSrc && (
          <div className="ai-generator-landing__hero-media">
            <img
              className="ai-generator-landing__hero-image"
              src={imageSrc}
              alt={imageAlt}
              width={imageWidth}
              height={imageHeight}
              // This is the LCP element -- never lazy, and hinted as high priority. The view
              // also emits a <link rel=preload> for it.
              // eslint-disable-next-line react/no-unknown-property
              fetchpriority="high"
              decoding="async"
            />
          </div>
        )}
      </div>
    </section>
  )
}

Hero.propTypes = {
  title: string,
  paragraphs: arrayOf(string),
  imageSrc: string,
  imageAlt: string,
  imageWidth: number,
  imageHeight: number,
  ctaLabel: string,
  subscriptionPaymentFormUrl: string,
  studioUrl: string,
}

export default Hero
